import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import {Toaster} from 'react-hot-toast';
import {AuthProvider} from './contexts/AuthContext';
import {TenantProvider} from './contexts/TenantContext';
import {SuperAdminProvider} from './contexts/SuperAdminContext';
import {ErrorProvider} from './contexts/ErrorContext';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './components/DashboardLayout';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import TenantManagement from './components/TenantManagement';
import SuperAdminDashboard from './components/SuperAdminDashboard';
// Customer Components
import Customers from './components/customers/Customers';
import CreateCustomer from './components/customers/CreateCustomer';
import EditCustomer from './components/customers/EditCustomer';
import CustomerDetail from './components/customers/CustomerDetail';
// Supplier Components
import Suppliers from './components/suppliers/Suppliers';
import CreateSupplier from './components/suppliers/CreateSupplier';
import EditSupplier from './components/suppliers/EditSupplier';
import SupplierDetail from './components/suppliers/SupplierDetail';
// Battery Components
import Batteries from './components/batteries/Batteries';
import CreateBattery from './components/batteries/CreateBattery';
import EditBattery from './components/batteries/EditBattery';
import BatteryDetail from './components/batteries/BatteryDetail';
// Battery Brand Components
import BatteryBrands from './components/battery-brands/BatteryBrands';
import CreateBatteryBrand from './components/battery-brands/CreateBatteryBrand';
import EditBatteryBrand from './components/battery-brands/EditBatteryBrand';
// Tire Components
import Tires from './components/tires/Tires';
import TireDetail from './components/tires/TireDetail';
import CreateTire from './components/tires/CreateTire';
import EditTire from './components/tires/EditTire';
// Tire Brand Components
import TireBrands from './components/tire-brands/TireBrands';
import CreateTireBrand from './components/tire-brands/CreateTireBrand';
import EditTireBrand from './components/tire-brands/EditTireBrand';
// Tire Type Components
import TireTypes from './components/tire-types/TireTypes';
import TireTypeDetail from './components/tire-types/TireTypeDetail';
import CreateTireType from './components/tire-types/CreateTireType';
import EditTireType from './components/tire-types/EditTireType';
// Battery Type Components
import BatteryTypes from './components/battery-types/BatteryTypes';
import BatteryTypeDetail from './components/battery-types/BatteryTypeDetail';
import CreateBatteryType from './components/battery-types/CreateBatteryType';
import EditBatteryType from './components/battery-types/EditBatteryType';
// Location Components
import Locations from './components/locations/Locations';
import LocationDetail from './components/locations/LocationDetail';
import CreateLocation from './components/locations/CreateLocation';
import EditLocation from './components/locations/EditLocation';
// MadeIn Components
import MadeIn from './components/madein/MadeIn';
import CreateMadeIn from './components/madein/CreateMadeIn';
import EditMadeIn from './components/madein/EditMadeIn';
// Pattern Components
import Patterns from './components/patterns/Patterns';
import PatternForm from './components/patterns/PatternForm';
import PatternDetail from './components/patterns/PatternDetail';
// Tags Components
import Tags from './components/tags/Tags';
import TagCreate from './components/tags/TagCreate';
import TagEdit from './components/tags/TagEdit';
import TagDetail from './components/tags/TagDetail';
// Wiper Products Components
import WiperProducts from './components/wiper-products/WiperProducts';
import WiperProductForm from './components/wiper-products/WiperProductForm';
import WiperProductDetail from './components/wiper-products/WiperProductDetail';
// Inventories Components
import InventoriesOverview from './components/inventories/InventoriesOverview';
// Invoices Components
import Invoices from './components/invoices/Invoices';
import CreateInvoice from "./components/invoices/CreateInvoice";
import InvoiceDetail from "./components/invoices/InvoiceDetail";
// Sales Components
import Sales from './components/sales/Sales';
import CreateSale from "./components/sales/CreateSale";
import SaleDetail from "./components/sales/SaleDetail";
//Receipts
import Receipts from "./components/receipts/Receipts";
import CreateReceipt from "./components/receipts/CreateReceipt";
import ReceiptDetail from "./components/receipts/ReceiptDetail";
//Purchase Orders
import Purchases from "./components/purchases/Purchases";
import CreatePurchase from "./components/purchases/CreatePurchase";
import PurchaseDetail from "./components/purchases/PurchaseDetail";
//Reports
import InventoryReport from "./components/reports/InventoryReport";
import SalesReport from "./components/reports/SalesReport";
import PurchasesReport from "./components/reports/PurchasesReport";
import CustomerBalanceReport from "./components/reports/CustomerBalanceReport";
import SupplierBalanceReport from "./components/reports/SupplierBalanceReport";
import './App.css';
import InventoryMovements from "./components/inventories/InventoryMovements";
import StockAdjustments from "./components/inventories/StockAdjustment";
import CreateStockAdjustment from "./components/inventories/CreateStockAdjustment";
// Zone Components
import ZoneList from './components/zones/ZoneList';
// Tenant Components
import Tenants from "./components/tenants/Tenants";
import CreateTenant from "./components/tenants/CreateTenant";
import EditTenant from "./components/tenants/EditTenant";
import TenantDetail from "./components/tenants/TenantDetail";

function App() {
    return (
        <Router>
            <ErrorProvider>
                <AuthProvider>
                    <SuperAdminProvider>
                        <TenantProvider>
                        <Routes>
                            {/* Public Routes */}
                            <Route path="/login" element={<Login/>}/>

                            {/* Protected Routes - Dashboard */}
                            <Route path="/" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <Dashboard/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>

                            {/* Super Admin Route */}
                            <Route path="/super-admin" element={
                                <ProtectedRoute requireSuperAdmin={true}>
                                    <SuperAdminDashboard/>
                                </ProtectedRoute>
                            }/>

                            {/* Tenant Management Route */}
                            <Route path="/tenant" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <TenantManagement/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Customer Routes */}
                            <Route path="/customers" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <Customers/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/customers/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreateCustomer/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/customers/:id/edit" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <EditCustomer/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/customers/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CustomerDetail/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Supplier Routes */}
                            <Route path="/suppliers" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <Suppliers/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/suppliers/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreateSupplier/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/suppliers/:id/edit" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <EditSupplier/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/suppliers/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <SupplierDetail/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Tenant Routes */}
                            <Route path="/tenants" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <Tenants/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/tenants/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreateTenant/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/tenants/:id/edit" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <EditTenant/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/tenants/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <TenantDetail/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Battery Routes */}
                            <Route path="/batteries" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <Batteries/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/batteries/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreateBattery/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/batteries/:id/edit" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <EditBattery/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/batteries/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <BatteryDetail/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Wiper products Routes */}
                            <Route path="/wiper-products" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <WiperProducts/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/wiper-products/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <WiperProductForm/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/wiper-products/edit/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <WiperProductForm/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/wiper-products/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <WiperProductDetail/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>

                            {/* Battery Brand Routes */}
                            <Route path="/battery-brands" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <BatteryBrands/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/battery-brands/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreateBatteryBrand/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/battery-brands/:id/edit" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <EditBatteryBrand/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Tire Routes */}
                            <Route path="/tires" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <Tires/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/tires/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <TireDetail/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/tires/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreateTire/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/tires/:id/edit" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <EditTire/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Tire Brand Routes */}
                            <Route path="/tire-brands" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <TireBrands/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/tire-brands/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreateTireBrand/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/tire-brands/:id/edit" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <EditTireBrand/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Patterns Routes */}
                            <Route path="/patterns" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <Patterns/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/patterns/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <PatternForm/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/patterns/:id/edit" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <PatternForm/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/patterns/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <PatternDetail/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Tags Routes */}
                            <Route path="/tags" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <Tags/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/tags/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <TagCreate/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/tags/:id/edit" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <TagEdit/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/tags/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <TagDetail/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Tire Type Routes */}
                            <Route path="/tire-types" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <TireTypes/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/tire-types/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreateTireType/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/tire-types/:id/edit" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <EditTireType/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/tire-types/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <TireTypeDetail/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Battery Type Routes */}
                            <Route path="/battery-types" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <BatteryTypes/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/battery-types/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreateBatteryType/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/battery-types/:id/edit" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <EditBatteryType/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/battery-types/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <BatteryTypeDetail/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Inventories Routes */}
                            <Route path="/inventories" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <InventoriesOverview/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/inventory-movements" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <InventoryMovements/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/stock-adjustments" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <StockAdjustments/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/stock-adjustments/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreateStockAdjustment/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>


                            {/* Invoices Routes */}
                            <Route path="/invoices" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <Invoices/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/invoices/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <InvoiceDetail/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/invoices/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreateInvoice/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Sales Routes */}
                            <Route path="/sales" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <Sales/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/sales/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreateSale/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/sales/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <SaleDetail/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Receipts Routes */}
                            <Route path="/receipts" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <Receipts/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/receipts/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreateReceipt/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/receipts/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <ReceiptDetail/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Purchase Routes */}
                            <Route path="/purchases" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <Purchases/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/purchases/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreatePurchase/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/purchases/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <PurchaseDetail/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* MadeIN Routes */}
                            <Route path="/made-ins" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <MadeIn/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/made-ins/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreateMadeIn/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/made-ins/:id/edit" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <EditMadeIn/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Reports Routes */}
                            <Route path="/reports/inventory" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <InventoryReport/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/reports/sales" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <SalesReport/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/reports/purchases" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <PurchasesReport/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/reports/customer-balance" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CustomerBalanceReport/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/reports/supplier-balance" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <SupplierBalanceReport/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Location Routes */}
                            <Route path="/locations" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <Locations/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/locations/create" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <CreateLocation/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/locations/:id/edit" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <EditLocation/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            <Route path="/locations/:id" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <LocationDetail/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>
                            {/* Zone Routes */}
                            <Route path="/zones" element={
                                <ProtectedRoute>
                                    <DashboardLayout>
                                        <ZoneList/>
                                    </DashboardLayout>
                                </ProtectedRoute>
                            }/>

                        </Routes>
                        </TenantProvider>
                    </SuperAdminProvider>
                </AuthProvider>
            </ErrorProvider>
            <Toaster
                position="top-right"
                toastOptions={{
                    duration: 4000,
                    style: {
                        background: '#363636',
                        color: '#fff',
                    },
                    success: {
                        duration: 3000,
                        style: {
                            background: '#10B981',
                        },
                    },
                    error: {
                        duration: 5000,
                        style: {
                            background: '#EF4444',
                        },
                    },
                }}
            />
        </Router>
    );
}

export default App;